  <div class="mobile-calc-shell">


<div class="mobile-busy-overlay" *ngIf="mobileBusy">
    <div class="mobile-busy-card">
      <div class="spinner-border" role="status"></div>
      <div class="mobile-busy-label">{{ mobileBusyLabel || 'Working…' }}</div>
    </div>
  </div>

  <div
    *ngIf="showTotalCostAlert"
    class="alert alert-warning alert-dismissible fade show mx-3 mt-2"
    role="alert"
  >
    <strong>⚠️ Please set the target total cost</strong> for the current selected product.<br>
    <small>The <strong>target total cost</strong> is the maximum allowable cost to produce an item and still achieve your desired profit.</small>
    <button type="button" class="btn-close" (click)="showTotalCostAlert = false" aria-label="Close"></button>
  </div>

  <div class="mobile-sticky-top" *ngIf="mobileView === 'calculator'">

  <!-- ── Single collapse toggle for the whole setup section ── -->
  <div class="sticky-collapse-toggle" (click)="toggleStickyTop()">
    <span class="sticky-collapse-label">
      <i class="bi bi-sliders2 me-2"></i>
      {{ selectedProductName || productName || 'Product Setup' }}
    </span>
    <i class="bi" [ngClass]="stickyTopOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
  </div>

  <div *ngIf="stickyTopOpen" class="sticky-collapse-panel">

  <!-- ── Metric Ribbon ───────────────────────────── -->
  <div class="calc-metric-ribbon-wrap">
    <app-mobile-metric-ribbon [metrics]="metrics"></app-mobile-metric-ribbon>
  </div>

  <!-- ── Product Selection ───────────────────────── -->
  <div class="product-selection-wrap px-3 py-2">

    <div class="product-section-panel">
      <div class="product-select-row">
        <div class="product-select-col flex-fill">
          <div class="product-select-and-edit">
            <div class="product-select-container flex-fill">
              <app-single-select-dropdown
                [options]="productOptions"
                [selectedValue]="selectedProductId ? String(selectedProductId) : null"
                placeholder="Select a product..."
                [allowAddNew]="true"
                addNewLabel="Add new product"
                [searchable]="true"
                (selectedValueChange)="onProductDropdownChange($event)"
                (addMore)="onAddNewProduct()">
              </app-single-select-dropdown>
            </div>

            <!-- Edit Product Button -->
            <div class="product-edit-btn-wrap" *ngIf="selectedProductId">
              <button class="product-edit-btn" (click)="openProductEdit()" title="Edit Product">
                <i class="bi bi-pencil-square"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pricing Section (only when a product is selected) -->
    <div *ngIf="selectedProductId" class="pricing-section mt-2">
      <div class="pricing-panel">
        <div class="target-cost-row">
          <div class="compact-markup-container">
            <label class="form-label fw-semibold mb-0 target-cost-label">
              Markup <input type="number" class="markup-pct-input" min="0" max="300" step="1"
                [(ngModel)]="profitMarginPercentage" (change)="onMarginChange()"
                [style.color]="getKnobColor()" />    %
            </label>
            <div class="markup-bar"
                 (mousedown)="onBarPointerDown($event)"
                 (touchstart)="onKnobTouchStart($event)"
                 (touchmove)="onKnobTouchMove($event)"
                 (touchend)="onKnobTouchEnd($event)">
              <div class="markup-bar-fill" [style.width.%]="markupFillPercent" [style.background]="getKnobColor()"></div>
              <div class="markup-bar-divider" style="left: 33.33%"></div>
              <div class="markup-bar-divider" style="left: 66.66%"></div>
              <div class="markup-bar-thumb" [style.left.%]="markupFillPercent"></div>
            </div>
          </div>

          <div class="target-cost-field">
            <label class="target-cost-label">Target Cost</label>
            <input type="number" class="target-cost-input"
                   [value]="targetTotalCost ?? ''"
                   (change)="onTargetCostChange($any($event.target).value)"
                   placeholder="e.g. 500"
                   min="0" step="0.01" />
          </div>
        </div>
      </div>

    </div>
  </div>

  </div>
  <!-- /sticky-collapse-panel -->

  </div>

  <!-- ── Category Cards (calculator view only) ── -->
  <ng-container *ngIf="mobileView === 'calculator'">
    <div class="cards-area px-3 pb-3">

      <div *ngIf="activeCards.length === 0" class="empty-state">
        <i class="bi bi-inbox fs-2 text-muted d-block mb-2"></i>
        <p class="text-muted mb-0">No items for this category yet.</p>
        <button *ngIf="activeTab !== 'fixedOverheads'" class="btn btn-primary btn-sm mt-2" (click)="openAddItemDialog()">
          <i class="bi bi-plus-circle me-1"></i>Add Item
        </button>
      </div>

      <app-mobile-data-card
        *ngFor="let card of activeCards; let i = index; trackBy: trackCard"
        [title]="card.itemName"
        [primaryValue]="card.category"
        [fields]="getCardFields(card)"
        [animationDelay]="i * 60"
        [fullItem]="card.fullItem"
        [expandable]="true"
        (editTap)="openOffcanvas(card)"
        (deleteTap)="onRequestDelete(card)"
      ></app-mobile-data-card>

    </div>

  </ng-container>

  <!-- ── Action Bar (Add + Save All) ─────────── -->
  <div class="action-bar" *ngIf="mobileView === 'calculator'">
    <div class="action-bar-top">
      <button class="action-btn-add" (click)="openAddItemDialog()">
        <i class="bi bi-plus-lg me-1"></i>Add Item
      </button>
    </div>
    <div
      *ngIf="fohBatchChangePending && activeTab === 'fixedOverheads'"
      class="alert alert-warning d-flex align-items-center justify-content-between py-2 px-3 mb-2"
      role="alert"
    >
      <span class="small">Batch size updated — changes not yet saved.</span>
      <button class="btn btn-sm btn-warning ms-2" (click)="onFOHSaveAll()" [disabled]="mobileBusy">Save All</button>
    </div>
    <button *ngIf="selectedProductId" class="save-all-btn" (click)="onSaveAll()" [disabled]="mobileBusy">
      <span *ngIf="mobileBusy" class="spinner-border spinner-border-sm me-2" role="status"></span>
      <i class="bi bi-save me-2"></i>Save All
    </button>
  </div>

  <!-- ── Summary View ───────────────────────────────── -->
  <div *ngIf="mobileView === 'summary'" class="cards-area px-3 pb-3">
    <div class="mobile-metric-card">
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead>
              <tr>
                <th class="fw-bold">Product</th>
                <th class="fw-bold text-end">Total Cost</th>
              </tr>
            </thead>
            <tbody>

              <!-- Selected product row — always first, auto-expanded -->
              <ng-container *ngIf="selectedSummaryEntry">
                <tr class="cursor-pointer" (click)="toggleExpand(selectedSummaryEntry.key)">
                  <td class="fw-semibold bg-white">
                    <i class="bi me-2" [ngClass]="{ 'bi-chevron-down': expandedProducts[selectedSummaryEntry.key] === false, 'bi-chevron-up': expandedProducts[selectedSummaryEntry.key] !== false }"></i>
                    {{ selectedSummaryEntry.key }}
                  </td>
                  <td class="text-end fw-bold bg-white">R{{ getProductTotal(selectedSummaryEntry.value) | number: '1.2-2' }}</td>
                </tr>
                <tr *ngIf="expandedProducts[selectedSummaryEntry.key] !== false" class="fade-in">
                  <td colspan="2" style="padding: 12px 0">
                    <div class="material-items-container">
                      <ng-container *ngFor="let cost of selectedSummaryEntry.value">
                        <div class="material-item">
                          <div class="material-icon"><i class="bi bi-cash-coin"></i></div>
                          <span class="material-name">{{ cost.itemOrRole }} ({{ cost.category }})</span>
                          <span class="badge quantity-badge">R{{ cost.unitCost | number: '1.2-2' }}</span>
                        </div>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-container>

              <!-- Show all products toggle -->
              <tr *ngIf="otherSummaryEntries.length > 0">
                <td colspan="2" class="text-center py-2 border-0">
                  <button class="summary-show-more-btn" (click)="showAllSummaryProducts = !showAllSummaryProducts">
                    <i class="bi me-1" [ngClass]="showAllSummaryProducts ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                    {{ showAllSummaryProducts ? 'Hide other products' : 'Show all products (' + otherSummaryEntries.length + ')' }}
                  </button>
                </td>
              </tr>

              <!-- Other product rows (hidden until toggled) -->
              <ng-container *ngIf="showAllSummaryProducts">
                <ng-container *ngFor="let entry of otherSummaryEntries">
                  <tr class="cursor-pointer" (click)="toggleExpand(entry.key)">
                    <td class="fw-semibold bg-white">
                      <i class="bi me-2" [ngClass]="{ 'bi-chevron-down': !expandedProducts[entry.key], 'bi-chevron-up': expandedProducts[entry.key] }"></i>
                      {{ entry.key }}
                    </td>
                    <td class="text-end fw-bold bg-white">R{{ getProductTotal(entry.value) | number: '1.2-2' }}</td>
                  </tr>
                  <tr *ngIf="expandedProducts[entry.key]" class="fade-in">
                    <td colspan="2" style="padding: 12px 0">
                      <div class="material-items-container">
                        <ng-container *ngFor="let cost of entry.value">
                          <div class="material-item">
                            <div class="material-icon"><i class="bi bi-cash-coin"></i></div>
                            <span class="material-name">{{ cost.itemOrRole }} ({{ cost.category }})</span>
                            <span class="badge quantity-badge">R{{ cost.unitCost | number: '1.2-2' }}</span>
                          </div>
                        </ng-container>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>

            </tbody>
          </table>
        </div>
    </div>
  </div>

  <!-- ── Graphs View ────────────────────────────────── -->
  <div *ngIf="mobileView === 'graphs'" class="cards-area graphs-area px-3 pb-3">
    <h5 class="fw-bold mb-3">Charts</h5>
    <app-donut-chart
      [selectedProductName]="selectedProductName || productName"
      [allProductCosts]="allProductCosts"
    ></app-donut-chart>
    <div class="mt-3">
      <app-cost-breakdown
        [directMaterials]="rawMaterials"
        [directLabor]="directLabor"
        [indirectLabor]="indirectLabor"
        [fixedOverheads]="fixedOverheads"
        [variableOverheads]="variableOverheads"
      ></app-cost-breakdown>
    </div>
  </div>

  <!-- ── AI Insights Tab View (styled like the budget page) ── -->
  <div *ngIf="mobileView === 'aivor'" class="m-ai-wrapper">
    <app-aivor-insights
      [tenantProfile]="tenantProfile"
      [productName]="selectedProductName || productName"
      [directMaterials]="rawMaterials"
      [directLabor]="directLabor"
      [indirectLabor]="indirectLabor"
      [fixedOverheads]="fixedOverheads"
      [variableOverheads]="variableOverheads"
      [competitors]="competitors"
      (suggestedPriceChange)="onAiSuggestedPriceChange($event)"
      (markupPriceChange)="onAiMarkupPriceChange($event)"
    ></app-aivor-insights>
  </div>

</div>

<!-- ── Delete Confirmation Bottom Sheet ──────────── -->
<div class="m-del-overlay"
  *ngIf="deleteSheetOpen"
  (click)="$event.target === $event.currentTarget && closeDeleteSheet()">
  <div class="m-del-sheet" (click)="$event.stopPropagation()"
    [style.transform]="deleteSwipeDeltaY ? 'translateY(' + deleteSwipeDeltaY + 'px)' : null"
    [style.transition]="deleteSwipeActive ? 'none' : 'transform 0.3s cubic-bezier(0.4,0,0.2,1)'">
    <div class="m-del-handle-bar"
      (touchstart)="onDeleteHandleTouchStart($event)"
      (touchmove)="onDeleteHandleTouchMove($event)"
      (touchend)="onDeleteHandleTouchEnd()">
      <div class="m-del-handle"
        [style.width.px]="36 + deleteSwipeProgress * 20"
        [style.background]="'rgb(' + Math.round(222 + deleteSwipeProgress * -222) + ',' + Math.round(226 + deleteSwipeProgress * (122 - 226)) + ',' + Math.round(230 + deleteSwipeProgress * (143 - 230)) + ')'">
      </div>
    </div>
    <div class="m-del-header">
      <h5 class="m-del-title">Remove Item</h5>
      <button class="m-del-close-btn" (click)="closeDeleteSheet()"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="m-del-body">
      <p class="m-del-text">
        Are you sure you want to <strong class="text-danger">remove </strong>
        <strong>{{ pendingDeleteCard?.itemName }}</strong>?
        This action cannot be undone.
      </p>
    </div>
    <div class="m-del-footer">
      <button class="btn m-del-btn-cancel flex-fill" (click)="closeDeleteSheet()">Cancel</button>
      <button class="btn m-del-btn-confirm flex-fill" (click)="confirmDelete()">Remove</button>
    </div>
  </div>
</div>

<!-- ── Edit Offcanvas ─────────────────────────── -->
<app-cost-item-offcanvas
  [visible]="offcanvasVisible"
  [item]="selectedItem"
  [employees]="employees"
  [fixedOverheadNames]="fixedOverheadNames"
  [variableOverheadItems]="variableOverheadItems"
  [materialNames]="materialNames"
  [accountType]="accountType"
  [uomList]="uomList"
  (close)="closeOffcanvas()"
  (save)="onItemSaved($event)"
></app-cost-item-offcanvas>
